module.exports = __webpack_public_path__ + "static/media/golfer-3-a.74ad458a.png";